// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__10tT-","content":"LoadingAlert_content__2yAWD"};